import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWN5MA (客訴單-業務經辦核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fn110_01: string;  // 客訴單號
  fn110_12: string;  // 客戶代號
  fn110_17: number;  // 賠償金額
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwn5maApi = {
  /** Query complaint orders eligible for approval reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwn5ma/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected complaint orders.
   * confirmed:true mirrors the Modal.confirm dialog the user already went
   * through in PWN5MAForm — the backend does not yet require this field
   * (disclosed gap, see
   * contexts/erp-contracts/forms/pwn5maf1/control.contract.yaml
   * PWN5MA-SRC-CURRENT-FRONTEND), but the frontend sends it so the wire
   * shape already matches every other CHAIN-16/18/01 batch-reversal
   * sibling (n5m3Api/pwn5n1Api/pwn5mbApi) once backend enforcement lands. */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwn5ma/reverse', { items, confirmed: true });
    return res.data;
  },
};
